let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3VwOo")).then(() => parcelRequire('1bNa1'));